import baseSpanishMessages from "@blackbox-vision/ra-language-spanish";

/**
 * @blackbox-vision/ra-language-spanish is stuck on 4.11.3 (react-admin v4) and
 * is missing 16 keys that react-admin 5.15 does use. This fills them in.
 *
 * The merge is per-namespace on purpose: a flat spread of `ra` would wipe out
 * the base package's other namespaces.
 *
 * To check whether new keys appeared after upgrading react-admin, diff against
 * node_modules/ra-language-english.
 */
const spanishMessages = {
  ...baseSpanishMessages,
  ra: {
    ...baseSpanishMessages.ra,
    action: {
      ...baseSpanishMessages.ra.action,
      // Restores the visible columns to their default configuration.
      reset: "Restablecer",
      search_columns: "Buscar columnas",
      // Selects every record across all pages. In English it reads the same as
      // `select_all` (the header checkbox, which only covers the current page).
      select_all_button: "Seleccionar todo",
    },
    page: {
      ...baseSpanishMessages.ra.page,
      access_denied: "Acceso denegado",
      authentication_error: "Error de autenticación",
    },
    message: {
      ...baseSpanishMessages.ra.message,
      access_denied:
        "No tiene los permisos necesarios para acceder a esta página",
      authentication_error:
        "El servidor de autenticación devolvió un error y no se pudieron verificar sus credenciales.",
      select_all_limit_reached:
        "Hay demasiados elementos para seleccionarlos todos. Solo se seleccionaron los primeros %{max} elementos.",
      placeholder_data_warning:
        "Problema de red: no se pudieron actualizar los datos.",
    },
    navigation: {
      ...baseSpanishMessages.ra.navigation,
      clear_filters: "Limpiar filtros",
      no_filtered_results:
        "No se han encontrado %{name} con los filtros actuales.",
    },
    auth: {
      ...baseSpanishMessages.ra.auth,
      email: "Correo electrónico",
    },
    notification: {
      ...baseSpanishMessages.ra.notification,
      offline: "Sin conexión. No se pudieron obtener los datos.",
    },
    validation: {
      ...baseSpanishMessages.ra.validation,
      unique: "Debe ser único",
    },
    // The `guesser` namespace does not exist in 4.11.3, so it goes in whole
    // without spreading the base.
    guesser: {
      empty: {
        title: "No hay datos para mostrar",
        message: "Verifique su proveedor de datos",
      },
    },
  },
};

export default spanishMessages;
